import { Sites } from '@ps/platform-message-framework/common/Sites';
import type { TrackedTranslation, TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import React, { useCallback } from 'react';
import { Field, useForm } from 'react-final-form';
import { useSelector } from 'react-redux';

import StarsSquareIconButton from '@swf/components/StarsSquareIconButton/StarsSquareIconButton';
import flags from '@swf/core/assets/flags';
import { select } from '@swf/core/store';

import {
  TXTWCL_Canadian_Citizen,
  TXTWCL_German_Citizen,
  TXTWCL_Romanian_Citizen,
  TXTWCL_You_are_a_citizen_of_CanadaX,
  TXTWCL_You_are_a_citizen_of_GermanyX,
  TXTWCL_You_are_a_citizen_of_RomaniaX
} from './Citizenship.messages.json';
import { squareButton, text } from './Citizenship.scss';

interface Props {
  active: boolean;
  handleClick(): void;
}

const translation: Partial<Record<Sites, TrackedTranslation>> = {
  [Sites.CA_ON]: TXTWCL_Canadian_Citizen,
  [Sites.DE]: TXTWCL_German_Citizen,
  [Sites.ROM]: TXTWCL_Romanian_Citizen
} as const;

const subTitle: Partial<Record<Sites, TranslationTag>> = {
  [Sites.CA_ON]: TXTWCL_You_are_a_citizen_of_CanadaX,
  [Sites.DE]: TXTWCL_You_are_a_citizen_of_GermanyX,
  [Sites.ROM]: TXTWCL_You_are_a_citizen_of_RomaniaX
} as const;

const Citizenship: React.FC<Props> = ({ active, handleClick }) => {
  const siteId = useSelector(select.cms.getSiteId);
  const detectedCountry = useSelector(select.account.getCountry) as string;
  const form = useForm();

  const getFlag: React.FC = () => (
    <img width={40} height={40} src={flags[detectedCountry]} alt={Sites[siteId]} />
  );

  const handleCitizenshipClick = useCallback(() => {
    handleClick();
    form.change('citizenship', detectedCountry);
  }, [handleClick, form, detectedCountry]);

  return (
    <>
      <Field name="citizenship" initialValue={detectedCountry}>
        {() => <input type="hidden" name="citizenship" id="citizenship" value={detectedCountry} />}
      </Field>
      <StarsSquareIconButton
        Icon={getFlag}
        active={active}
        dataTestId="citizenship"
        className={squareButton}
        groupTextClassName={text}
        onClick={handleCitizenshipClick}
        translation={{
          tag: translation[siteId] || TXTWCL_Canadian_Citizen
        }}
        subTitle={
          <Translation
            tagName="small"
            {...(subTitle[siteId] || TXTWCL_You_are_a_citizen_of_CanadaX)}
          />
        }
      />
    </>
  );
};

export default Citizenship;
